import http from '@/communication/AuthConnection'

export default ({ labName }) => {
  return http.get('/v1/labs/search-by-name', { params: { lab: labName } })
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/lab/search-labs-by-name/index.js